import cx from 'classnames'
import type React from 'react'
import styled from 'styled-components'

import { PageTitle } from '@components/PageTitle'
import { PublicNavbar } from '@components/PublicNavbar'

import { generateMaxHeightBreakPoint, generateMaxWidthBreakPoint } from '@constants'

import blue_theme_auth_bg_mobile from '@assets/img/blue_theme_auth_bg_mobile.svg'
import purple_theme_auth_bg_mobile from '@assets/img/purple_theme_auth_bg_mobile.svg'

import { PageNoIndexMeta } from '../PageMeta'

const CLASS_KEYS = {
  designPage: 'design-page',
}

const PageWrapper = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.gray[102]};
  color: ${({ theme }) => theme.colors.common.offBlack};
  display: flex;
  flex-wrap: wrap;
  min-height: calc(100vh - ${({ theme }) => theme.newVersionBarOffset});
  padding-bottom: 20px;
  padding-top: ${({ theme }) => theme.appBarHeight + 20}px;
  width: 100%;

  /* TODO: Check this style */
  && > header {
    border: none;
  }

  ${generateMaxHeightBreakPoint('medium')} {
    padding-top: ${({ theme }) => theme.appBarHeightMedium + 20}px;
  }

  &.${CLASS_KEYS.designPage} {
    min-width: 340px;
    background-color: ${({ theme }) => theme.colors.common.darkBlue};
    position: relative;

    ${generateMaxWidthBreakPoint('mobile')} {
      background-position: center ${({ theme }) => theme.appBarHeight}px;
      background-repeat: no-repeat;
      background-attachment: fixed;

      &.blueTheme {
        background-image: url(${blue_theme_auth_bg_mobile});
      }

      &.purpleTheme {
        background-image: url(${purple_theme_auth_bg_mobile});
      }
    }
  }
`

interface BasePublicPageProps {
  children: React.ReactNode | React.ReactNode[]
  /** For boot screens, which cannot know the company's brand yet. */
  hideNavbar?: boolean
  subtitle?: string
  theme?: 'default' | 'blue' | 'purple'
  withExtraDesign?: boolean
}

export function PublicPage({
  children,
  hideNavbar = false,
  subtitle,
  withExtraDesign = false,
  theme = 'default',
}: BasePublicPageProps) {
  return (
    <PageWrapper
      className={cx(
        {
          [CLASS_KEYS.designPage]: withExtraDesign,
        },
        `${theme}Theme`
      )}
    >
      {subtitle && <PageTitle subtitle={subtitle} />}
      <PageNoIndexMeta />
      <PublicNavbar isHidden={hideNavbar} withExtraDesign={withExtraDesign} />
      {children}
    </PageWrapper>
  )
}
